<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float: left;">Место работы стоматолога "{{ employeeFullName }}"</h3>
          <v-btn color="pink" dark small fab @click="openEditingModal()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down" />
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-data-table :headers="headers" :search="search" :items="items" :rows-per-page-items="[10, 25]"
                class="elevation-1" item-key="id" no-results-text="Нет результатов" rows-per-page-text="На странице"
                v-model="selectedItems">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>{{ props.item.id }}</td>
                    <td>{{ getClinicNameById(props.item.shopId) }}</td>
                    <td>{{ props.item.isPrimaryEmployment ? 'Да' : 'Нет' }}</td>
                    <td>{{ getPositionNameById(props.item.positionId) }}</td>
                    <td>{{ getSpecializationNameById(props.item.specializationId) }}</td>
                    <td>
                      <v-btn depressed outline icon fab dark color="primary" small
                        @click="openEditingModal(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>

                      <v-btn depressed outline icon fab dark color="pink" small @click="openRemovingModal(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">
                <v-dialog v-model="editingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        {{ editedIndex === -1 ? 'Добавление' : 'Редактирование' }}
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="isEditing">
                          <v-flex xs4>
                            <v-subheader>ID</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID" v-model="modalData.id" readonly />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Клиника</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Клиника" :items="clinics" no-data-text="Нет данных"
                              v-model="modalData.shopId" :rules="rules.required" required />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Должность</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-select label="Должность" :items="positions" item-text="name" item-value="id"
                              v-model="modalData.positionId" :rules="rules.required" required />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Специализация</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-select label="Специализация" :items="specializations" item-text="specializationTitle"
                              item-value="specializationId" v-model="modalData.specializationId"
                              :rules="rules.specializationRequired" :readonly="!specializationRequired" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Основное рабочее место</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isPrimaryEmployment"
                              :rules="rules.onlyOnePrimaryEmployment(modalData.id, items)" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>isOrdering</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isOrdering" />
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn flat @click="closeEditingModal()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="removingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить запись?</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="closeRemovingModal()">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="remove(modalData)">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      employeeId: +this.$route.params.id,
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Клиника',
          value: 'shopId',
        },
        {
          text: 'Основное рабочее место',
          value: 'isPrimaryEmployment',
        },
        {
          text: 'Должность',
          value: 'positionId',
        },
        {
          text: 'Специализация',
          value: 'specializationId',
        },
        {
          text: 'Действия',
          value: '',
        },
      ],
      search: '',
      selectedItems: [],
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      isEditing: true,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        onlyOnePrimaryEmployment: (editingItemId, items) => [v => {
          if (!v) return true;

          const predicate = editingItemId === -1
            ? i => i.isPrimaryEmployment
            : i => i.isPrimaryEmployment && i.id !== editingItemId;

          return !items.find(predicate) || 'Стоматолог должен иметь только одно основное рабочее место';
        }],
        specializationRequired: [v => {
          if (!this.specializationRequired || !!v) return true;
          return 'Для указанной должности необходимо выбрать специализацию'
        }],
      },
      editingModalOpened: false,
      removingModalOpened: false,
    };
  },

  mounted: function () {
    this.refresh();

    if (!this.$store.getters['shopEmployeePosition/shopEmployeePositionData'].length) {
      this.$store.dispatch('shopEmployeePosition/getShopEmployeePositionData');
    }

    if (!this.$store.getters['specialization/specializationData'].length) {
      this.$store.dispatch('specialization/getSpecializationData');
    }

    if (!this.$store.getters['clinics/items'].length) {
      this.$store.dispatch('clinics/loadItems');
    }
  },

  destroyed: function () {
    this.$store.commit('employeeEmployments/setItems', { items: [] });
  },

  computed: {
    items() {
      return this.$store.getters['employeeEmployments/items'];
    },

    employeeFullName() {
      const employee = this.$store.getters['employees/items'].find(e => e.id === this.employeeId)
      return `${employee.lastName} ${employee.firstName}` + (employee.middleName ? ` ${employee.middleName}` : '');
    },

    clinics() {
      return this.$store.getters['clinics/items'].map(cl => ({
        text: cl.name + ', ' + cl.address,
        value: cl.id,
      }));
    },

    positions() {
      return this.$store.getters['shopEmployeePosition/shopEmployeePositionData'];
    },

    specializations() {
      return this.$store.getters['specialization/specializationData'];
    },

    selectedPosition() {
      return this.positions.find(p => p.id === this.modalData.positionId);
    },

    specializationRequired() {
      return this.selectedPosition && this.selectedPosition.isSpecialization;
    },
  },


  watch: {
    selectedPosition(newVal) {
      if (!newVal) return;

      if (!newVal.isSpecialization) {
        this.modalData.specializationId = null;
      }

      this.$refs.form.validate();
    },
  },

  methods: {
    refresh() {
      this.$store.dispatch('employeeEmployments/loadItems', { employeeId: this.employeeId });
    },

    getClinicNameById(id) {
      const clinic = this.$store.getters['clinics/itemById'](id);
      return clinic ? `${clinic.name}, ${clinic.address}` : '--';
    },

    getPositionNameById(id) {
      const position = this.positions.find(p => p.id === id);
      return position ? position.name : '--';
    },

    getSpecializationNameById(id) {
      const specialization = this.specializations.find(s => s.specializationId === id);
      return specialization ? specialization.specializationTitle : '--';
    },

    loadModalData(item) {
      if (!item) {
        this.modalData = {
          id: -1,
          shopId: null,
          shopEmployeeId: this.employeeId,
          isPrimaryEmployment: false,
          positionId: 0,
          specializationId: null,
          isOrdering: false,
        };
        this.oldModalData = {};
        this.editedIndex = -1;
        this.isEditing = false;
      } else {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.items.indexOf(item);
        this.isEditing = true;
      }
    },

    openEditingModal(item) {
      this.loadModalData(item);
      this.editingModalOpened = true;
    },

    closeEditingModal() {
      if (this.editedIndex !== -1) {
        this.modalData = Object.assign(this.items[this.editedIndex], this.oldModalData);
      }

      this.editingModalOpened = false;
    },

    closeRemovingModal() {
      this.removingModalOpened = false;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch('employeeEmployments/save', { index: this.editedIndex, data: this.modalData });
        this.refresh();
        this.editingModalOpened = false;
      }
    },

    openRemovingModal(data) {
      this.modalData = data;
      this.removingModalOpened = true;
    },

    async remove(item) {
      await this.$store.dispatch('employeeEmployments/remove', { item });
      this.refresh();
      this.closeRemovingModal();
    },
  }
};

</script>


// WEBPACK FOOTER //
// src/pages/ui/EmployeeEmployments.vue